<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6-6-6 1.41-1.42z"/>
    </svg>
</template>

<script>
export default {
    name: 'ChevronDownIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
